<template>
  <div class="compact-register-container">
    <v-container fluid class="compact-register-inner">
      <div class="compact-register-content">
        <v-row class="compact-register-row">
          <v-col
            cols="10"
            style="
              display: flex;
              flex-direction: column;
              overflow: hidden;
              height: 100%;
            "
          >
            <div
              v-if="
                lastBalanceTimestamp && lastBalanceTimestamp !== '' && !showForm
              "
              style="padding-left: 5%; font-weight: bold"
            >
              Računi izdani nakon {{ lastBalanceTimestamp }}
            </div>
            <!-- Inicijalno stanje: prikazuje se samo lista računa -->
            <div
              v-show="!showForm"
              style="flex: 1; overflow-y: auto; overflow-x: hidden"
            >
              <Receipts
                ref="receiptsComponent"
                style="padding-top: 25px"
                :receiptFilter="receiptFilter"
              ></Receipts>
            </div>

            <!-- Kada se otvara forma za novi račun -->
            <div
              v-show="showForm"
              style="
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
              "
            >
              <crud-template-dialog
                ref="crudDialog"
                :tab-mode="true"
                :use-compact-cart-items="true"
                @close="onFormClose"
                @receipt-issued="onReceiptIssued"
                @open-search-modal="openSearchDialog"
              ></crud-template-dialog>
            </div>
          </v-col>
          <v-col cols="2" style="text-align: center; flex-shrink: 0">
            <table>
              <tbody>
                <tr v-if="teaserVisible">
                  <td>
                    <div class="pos-teaser">
                      <button class="pos-teaser-close" @click="openTeaserDialog('dismiss')">✕</button>
                      <div class="pos-teaser-title">✨ AIKASA SMART POS</div>
                      <div class="pos-teaser-desc">Isprobaj moderniji, brži i pregledniji dizajn kreiran za još lakši svakodnevni rad.</div>
                      <button class="pos-teaser-btn" @click="openTeaserDialog('switch')">Prebaci se na novi izgled</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="teaserVisible"><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <v-btn
                      id="success"
                      style="width: 100%"
                      class="btn soft-button"
                      @click="openNewReceipt"
                      :disabled="showForm"
                    >
                      Novi račun
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td><div class="section-header">PREGLED</div></td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      id="info"
                      style="width: 100%"
                      class="btn soft-button"
                      @click="showReceiptsList"
                      :disabled="!showForm"
                    >
                      Računi i Ponude
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td><div class="section-header">BLAGAJNA</div></td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      id="warning"
                      class="btn warning-button"
                      style="width: 100%"
                      @click="openCloseBalance"
                    >
                      Zaključak
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </div>
      <close-balance ref="closeBalance"></close-balance>
    </v-container>

    <!-- Article Search Dialog -->
    <compact-search-items-dialog
      v-if="searchItemsDialogOpen"
      :keyboard-shortcuts-enabled="true"
      :display-mode="'rows'"
      :quantity-bar-enabled="true"
      :item-quantities="itemQuantities"
      @addProduct="onAddProduct"
      @removeProduct="onRemoveProduct"
      @closeSearchItemsDialog="closeSearchDialog"
    />

    <!-- Teaser info modal -->
    <v-dialog v-model="teaserDialog" max-width="420" persistent>
      <v-card style="border-radius:14px; overflow:hidden;">
        <div style="padding:20px 20px 8px; display:flex; align-items:center; gap:10px;">
          <v-icon color="#00BCD4" size="22">mdi-information-outline</v-icon>
          <span style="font-size:15px; font-weight:700; color:#1e293b;">{{ teaserAction === 'switch' ? 'Prebacivanje na Aikasa Smart POS' : 'Promjena izgleda blagajne' }}</span>
        </div>
        <div style="padding:8px 20px 20px; font-size:13px; color:#374151; line-height:1.7;">
          Izgled blagajne možete u svakom trenutku promijeniti klikom na <v-icon size="15" color="#374151" style="vertical-align:middle;">mdi-cog</v-icon> gumb u headeru i odabirom željenog izgleda iz padajućeg izbornika.
        </div>
        <div style="padding:0 16px 16px; display:flex; justify-content:flex-end; gap:8px;">
          <v-btn text @click="teaserDialog = false" style="font-size:13px;">Zatvori</v-btn>
          <v-btn v-if="teaserAction === 'switch'" color="#00BCD4" dark depressed style="font-size:13px; border-radius:8px;" @click="confirmSwitch">Prebaci se</v-btn>
          <v-btn v-else color="#00BCD4" dark depressed style="font-size:13px; border-radius:8px;" @click="teaserDialog = false; dismissTeaser()">Razumijem</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import CrudTemplateDialog from '@/modules/cash-register/components/dialogs/CrudTemplateDialog'
import Receipts from '@/modules/company/components/receipts/Receipts'
import CloseBalance from '@/modules/cash-register/components/closeBalance/CloseBalance'
import CompactSearchItemsDialog from '@/modules/cash-register/components/dialogs/CompactSearchItemsDialog'
import EventBus from '@/plugins/event-bus'
import state from '@/state'
import { df } from '@/plugins/firebase'

export default {
  name: 'CompactRegister',
  components: {
    Receipts,
    CrudTemplateDialog,
    CloseBalance,
    CompactSearchItemsDialog
  },
  data () {
    return {
      teaserVisible: localStorage.getItem(`shop_teaser_dismissed_${state.getCashRegister().id}`) !== '1',
      teaserDialog: false,
      teaserAction: null,
      receiptFilter: {
        oibFilter: undefined,
        reciptOffer: 'receipts',
        modal: true,
        registerId: state.getCashRegister().id,
        lastBalanceTimestamp: state.getCashRegister().last_balance_timestamp,
        hideFilter: true
      },
      showForm: false, // Kontrolira prikaz forme vs. liste računa
      searchItemsDialogOpen: false // Kontrolira prikaz search dialoga
    }
  },
  computed: {
    lastBalanceTimestamp () {
      const balanceTimestamp = state.getCashRegister().last_balance_timestamp
      if (balanceTimestamp) {
        return this.$options.filters.local(balanceTimestamp)
      }
      return ''
    },
    itemQuantities () {
      // Calculate quantities of each item in cart for the search dialog
      const quantities = {}
      if (this.$refs.crudDialog && this.$refs.crudDialog.cart) {
        // Force dependency on cartVersion to trigger re-computation
        const version = this.$refs.crudDialog.cartVersion

        this.$refs.crudDialog.cart.forEach(cartItem => {
          if (cartItem.data && cartItem.data.id && cartItem.data.name) {
            // Use item ID (without warehouse unit suffix)
            const itemId = cartItem.data.id.includes('.')
              ? cartItem.data.id.split('.')[0]
              : cartItem.data.id

            if (!quantities[itemId]) {
              quantities[itemId] = 0
            }
            quantities[itemId] += cartItem.quantity || 0
          }
        })
      }
      return quantities
    }
  },

  mounted () {
    // Listen for cash register refresh
    EventBus.$off('refreshCashRegister')
    EventBus.$on('refreshCashRegister', () => {
      if (this.$refs.receiptsComponent && !this.showForm) {
        this.$refs.receiptsComponent.changeBalanceTimestampFilter(
          state.getCashRegister().last_balance_timestamp
        )
      }
    })

    // Add keyboard listener for F key
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    // Remove keyboard listener
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    openTeaserDialog (action) {
      this.teaserAction = action
      this.teaserDialog = true
    },
    dismissTeaser () {
      this.teaserVisible = false
      localStorage.setItem(`shop_teaser_dismissed_${state.getCashRegister().id}`, '1')
    },
    async confirmSwitch () {
      this.teaserDialog = false
      await this.switchToSmartPos()
    },
    async switchToSmartPos () {
      this.dismissTeaser()
      try {
        const registerId = state.getCashRegister().id
        await df.doc(`cash_registers/${registerId}`).set({ register_template: 'ai-shop' }, { merge: true })
        state.setRegisterType('ai-shop')
        EventBus.$emit('change-register-template', 'ai-shop')
      } catch (err) {
        console.error('switchToSmartPos: greška pri spremanju', err)
      }
    },
    openNewReceipt () {
      this.showForm = true
      this.$nextTick(() => {
        const register = state.getCashRegister()
        if (this.$refs.crudDialog) {
          // Reset loading state prije otvaranja
          this.$refs.crudDialog.loading = false
          this.$refs.crudDialog.open(null, register, null)
        }
      })
    },
    onFormClose () {
      // Called when user closes the form
      // Reset loading state
      if (this.$refs.crudDialog) {
        this.$refs.crudDialog.loading = false
      }
      this.showForm = false
    },
    onReceiptIssued () {
      // Called when receipt is successfully created
      // Reset loading state
      if (this.$refs.crudDialog) {
        this.$refs.crudDialog.loading = false
      }
      this.showForm = false
      // Refresh receipts list
      if (this.$refs.receiptsComponent) {
        this.$refs.receiptsComponent.changeBalanceTimestampFilter(
          state.getCashRegister().last_balance_timestamp
        )
      }
    },
    showReceiptsList () {
      // Return to receipts list view
      // Reset loading state
      if (this.$refs.crudDialog) {
        this.$refs.crudDialog.loading = false
      }
      this.showForm = false
    },
    openCloseBalance () {
      if (this.$refs.closeBalance) {
        this.$refs.closeBalance.open()
      }
    },

    // ===== Keyboard Handler =====
    handleKeydown (event) {
      // Only when form is visible
      if (!this.showForm) return

      // Don't capture F key when typing in input fields
      const inInputField = ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)
      if (inInputField) return

      // Don't open if dialog is already open
      if (this.searchItemsDialogOpen) return

      // F key opens search dialog
      if (event.key === 'f' || event.key === 'F') {
        event.preventDefault()
        this.openSearchDialog()
      }
    },

    openSearchDialog () {
      this.searchItemsDialogOpen = true
    },

    closeSearchDialog () {
      this.searchItemsDialogOpen = false
    },

    // ===== Product Addition =====
    onAddProduct (item, quantity) {
      if (!this.$refs.crudDialog) {
        console.error('CrudTemplateDialog ref not available')
        return
      }
      this.addProductToCrudDialog(item, quantity)
    },

    onRemoveProduct (item, quantity) {
      if (!this.$refs.crudDialog) {
        console.error('CrudTemplateDialog ref not available')
        return
      }
      this.removeProductFromCart(item, quantity)
    },

    removeProductFromCart (item, quantityToRemove) {
      const crudDialog = this.$refs.crudDialog

      // Find item in cart by ID
      const [itemId] = item.id.includes('.') ? item.id.split('.') : [item.id]

      const existingIndex = crudDialog.cart.findIndex(cartItem => {
        if (!cartItem.data || !cartItem.data.id) return false
        const cartItemId = cartItem.data.id.includes('.')
          ? cartItem.data.id.split('.')[0]
          : cartItem.data.id
        return cartItemId === itemId && cartItem.data.name
      })

      if (existingIndex === -1) return // Item not in cart

      // Decrease quantity
      const newQuantity = crudDialog.cart[existingIndex].quantity - (quantityToRemove || 1)

      if (newQuantity <= 0) {
        // Remove item completely if quantity is 0 or less
        crudDialog.removeCartItem(existingIndex)
      } else {
        // Just decrease quantity
        crudDialog.cart[existingIndex].quantity = newQuantity
        crudDialog.cart[existingIndex].formattedQuantity = newQuantity.toFixed(2).replace('.', ',')
        crudDialog.updateCartItem(existingIndex)
      }
    },

    async addProductToCrudDialog (item, quantity) {
      const crudDialog = this.$refs.crudDialog

      // Check if this item already exists in cart (by item id)
      const [itemId] = item.id.includes('.') ? item.id.split('.') : [item.id]

      const existingIndex = crudDialog.cart.findIndex(cartItem => {
        if (!cartItem.data || !cartItem.data.id) return false
        // Match by item ID (ignore warehouse unit suffix for comparison)
        const cartItemId = cartItem.data.id.includes('.')
          ? cartItem.data.id.split('.')[0]
          : cartItem.data.id
        return cartItemId === itemId && cartItem.data.name // Must have a name (not empty)
      })

      // If item already exists, just increase quantity
      if (existingIndex !== -1) {
        const newQuantity = crudDialog.cart[existingIndex].quantity + (quantity || 1)
        crudDialog.cart[existingIndex].quantity = newQuantity
        crudDialog.cart[existingIndex].formattedQuantity = newQuantity.toFixed(2).replace('.', ',')
        crudDialog.updateCartItem(existingIndex)
        return
      }

      // Find first empty cart slot
      let targetIndex = crudDialog.cart.findIndex(cartItem =>
        !cartItem.data || !cartItem.data.name || cartItem.data.name === ''
      )

      // If no empty slot, manually add new empty item at the end
      if (targetIndex === -1) {
        // Manually create and push a new empty cart item
        const newEmptyItem = {
          data: { name: '', type: undefined },
          quantity: 1,
          formattedQuantity: '1,00',
          price: 0,
          manualPrice: 0,
          formattedPrice: '0,00',
          discountAmt: 0,
          formattedDiscount: '0,00',
          formattedVpcPrice: '0.00',
          unit: undefined,
          units: [],
          unitsAndPrices: [],
          tax: undefined,
          taxCategory: undefined,
          taxExemptionReason: undefined,
          kpdcode: ''
        }

        crudDialog.cart.push(newEmptyItem)
        crudDialog.searchKeywords.push('')
        crudDialog.selectedItems.push({ data: { name: '', id: '', searchName: '' } })
        crudDialog.comboboxes.push({ disabled: false })
        targetIndex = crudDialog.cart.length - 1
      }

      // Fetch full item data from Firestore to get proper structure
      const fullItem = await this.fetchFullItemData(item)

      if (!fullItem) {
        console.error('Failed to fetch full item data')
        return
      }

      // Set selectedItems and trigger selectItem (this will populate tax, price, etc.)
      crudDialog.setupItem(fullItem)
      crudDialog.selectedItems[targetIndex] = fullItem
      crudDialog.selectItem(targetIndex)

      // Apply quantity if different from 1
      if (quantity && quantity !== 1) {
        crudDialog.cart[targetIndex].quantity = quantity
        crudDialog.cart[targetIndex].formattedQuantity = quantity.toFixed(2).replace('.', ',')
        crudDialog.updateCartItem(targetIndex)
      }
    },

    async fetchFullItemData (searchItem) {
      try {
        // Parse item ID (format: "itemId" or "itemId.unitId")
        const [itemId, unitId] = searchItem.id.includes('.')
          ? searchItem.id.split('.')
          : [searchItem.id, null]

        // Determine collection type based on item type
        const isMenuProduct = searchItem.type === 'menu-product'
        const collectionName = isMenuProduct ? 'location_menu_pricelist' : 'location_pricelist'

        // Fetch from Firestore
        const { doc, getDoc } = await import('firebase/firestore')
        const { df } = await import('@/plugins/firebase')

        const docRef = doc(df, collectionName, state.getPointOfSale().id, 'items', itemId)
        const docSnap = await getDoc(docRef)

        if (!docSnap.exists()) {
          console.error('Item not found in Firestore')
          return null
        }

        const itemData = docSnap.data()

        // If this is a warehouse unit item, we need to handle it specially
        if (unitId && itemData.warehouse_units && itemData.warehouse_units.units) {
          const warehouseUnit = itemData.warehouse_units.units[unitId]
          if (warehouseUnit) {
            // Clone the item data and use the specific warehouse unit
            return {
              data: {
                ...itemData,
                id: itemId,
                searchName: searchItem.label,
                prices: warehouseUnit.prices
              }
            }
          }
        }

        // Regular item without warehouse units
        return {
          data: {
            ...itemData,
            id: itemId,
            searchName: searchItem.label
          }
        }
      } catch (error) {
        console.error('Error fetching item data:', error)
        return null
      }
    }
  }
}
</script>
<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.15);
}
tr:hover {
  cursor: pointer;
}
td {
  background-color: white;
  padding: 2px;
}

/* Section headers with gradient text */
.section-header {
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #00bcd4 0%, #2196f3 50%, #9c27b0 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  padding: 4px 0;
}

/* Soft button style - white background with blue text and glass effect */
.soft-button {
  background: white !important;
  color: #2196f3 !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(33, 150, 243, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

.soft-button:hover {
  background: linear-gradient(135deg, rgba(0, 188, 212, 0.05) 0%, rgba(33, 150, 243, 0.05) 50%, rgba(156, 39, 176, 0.05) 100%) !important;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15) !important;
  transform: translateY(-1px);
}

.soft-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(33, 150, 243, 0.2) !important;
}

.soft-button:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Warning button style - orange gradient */
.warning-button {
  background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.25) !important;
  border: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
}

.warning-button:hover {
  background: linear-gradient(135deg, #fb8c00 0%, #f4511e 100%) !important;
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.35) !important;
  transform: translateY(-1px);
}

.warning-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(255, 152, 0, 0.3) !important;
}
</style>

<style>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.compact-register-container {
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  top: 0;
}

.compact-register-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px !important;
}

.compact-register-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.compact-register-row {
  flex: 1;
  overflow: hidden;
  margin: 0 !important;
}
.pos-teaser {
  background: rgba(0,188,212,0.10);
  border: 1.5px solid rgba(0,188,212,0.25);
  border-radius: 14px;
  padding: 12px 12px 10px;
  margin: 0 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}
.pos-teaser-close {
  position: absolute;
  top: 6px; right: 8px;
  background: transparent;
  border: none;
  color: #00838F;
  font-size: 13px;
  cursor: pointer;
  opacity: 0.6;
  line-height: 1;
  padding: 0;
  transition: opacity 0.15s;
}
.pos-teaser-close:hover { opacity: 1; }
.pos-teaser-title { font-size: 11px; font-weight: 800; color: #00838F; letter-spacing: 0.5px; text-transform: uppercase; }
.pos-teaser-desc { font-size: 12px; color: #374151; line-height: 1.5; }
.pos-teaser-btn {
  margin-top: 4px;
  width: calc(100% - 8px);
  margin-left: 4px;
  margin-right: 4px;
  padding: 9px 8px;
  background: #00BCD4;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  box-shadow: 0 2px 8px rgba(0,188,212,0.30);
}
.pos-teaser-btn:hover { background: #0097A7; }
</style>
